<style>
    .my-pagination /deep/ .ngx-pagination {
      text-align: center;
  
    }
  </style>
  <div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
        <li class="breadcrumb-item"><a routerLink="/corporate/campaign-event-builder">Campaign Event Builder</a></li>
        <li class="breadcrumb-item active" aria-current="page">Events</li>
      </ol>
    </nav>
  </div>
  <div class="container mt-2 themeTblReso">
    <div class="row">
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
                aria-hidden="true"></i></span>
          </div>
          <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText
          [disabled]="companyID == 0">
        </div>
  
      </div>
  
  
      <div class="col-md-4" style="justify-content: right;">
        <input type="button" value="Add New" *ngIf="isWrite" class="custbtn mt-md-1 ml-0" routerLink="/corporate/add-campaign-event">
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-6 mt-2">
        <div>
          <select name="company" class="form-control formstyle" (change)="onCompanyChange($event.target.value)">
            <option value="0">Select Company Name</option>
            <option *ngFor="let userObj of getCompanyobj" value={{userObj.customer_id}}>
              {{userObj.customer_company_name}}
            </option>
          </select>
  
        </div>
  
      </div>
    </div>
    <div class="tblPrt">
      <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <th>Title</th>
          <th> CreatedOn</th>
          <th> ModifiedOn</th>
          <th *ngIf="isEdit || isDelete">Actions</th>
        </tr>
  
        <tr *ngFor="let obj of eventObj">
          <td>{{obj.title}}</td>
          <td>{{obj.createdon | date:'mediumDate'}}</td>
          <td>{{obj.updatedon | date:'mediumDate' }}</td>
          <td *ngIf="isEdit || isDelete">
            <div class="actBtn">
              <i class="fa fa-edit mr-1" *ngIf="isEdit" (click)="editSection(obj.id)" placement="bottom"
                ngbTooltip="Edit"></i>
              <span class="fa fa-trash mr-1" *ngIf="isDelete" (click)="deleteSection(obj.id)" placement="bottom"
                ngbTooltip="Delete"></span>
              <mat-slide-toggle class="my-slider" [checked]="obj.is_active" *ngIf="isEdit"
                (click)="updateStatus($event,obj.id,obj.is_active)">
              </mat-slide-toggle>
            </div>
          </td>
        </tr>
  
      </table>
      <div style="text-align: center;" *ngIf="totalCount == 0">
        <p>No Result Available</p>
      </div>
      <div class="mt-2 text-center difPagination" *ngIf="totalCount > 10">
        <ngb-pagination [collectionSize]="totalCount" [(page)]="page" [maxSize]="2" [rotate]="true"
          (pageChange)="getCompanyCampaign(page = $event)" aria-label="Custom pagination">
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
        </ngb-pagination>
      </div>
    </div>